import request from "@/utils/request";

export function getQiniuToken() {
  return request({
    url: "/api/common/upload/token",
    method: "get",
    params: {}
  });
}

/**
 * 获取验证码图片【ok】
 * @param key
 */
export function getVerifyCode(key) {
  return request({
    url: "/common/getCaptcha",
    method: "get",
    params: {
      captchaKey: key,
      model: 'NUMBER_AND_ALPHABET_IGNORE_CASE',
    }
  });
}

export function sendSmsCode(phone) {
  return request({
    url: "/api/common/sms/code",
    method: "get",
    params: {
      phone: phone
    }
  });
}

/**
 * 查询级联地区【OK】
 * @param params 父级id
 */
export function getCascadeRegion(params) {
  return request({
    url: "/region/getCascadeRegion",
    method: "get",
    params
  });
}


// export const uploadImgApi =
//   process.env.VUE_APP_BASE_API + "/common/upload/image";
/**
 * 上传文件 【OK】
 * @type {string}
 */
export function uploadImage(params) {
  const formData = new FormData();
  formData.append("file", params.file);
  formData.append("type", params.type);
  return request.post('/common/upload/image',formData);
}

/**
 * 上传文档
 * @type {string}
 */
export const uploadDoc = process.env.VUE_APP_BASE_API + "/api/common/uploadDoc";
/**
 * 上传视频
 * @type {string}
 */
export const uploadVideo =
  process.env.VUE_APP_BASE_API + "/api/common/uploadVideo";

/**
 * 查询快递公司
 * @param params 父级id
 */
export function getExpress(params) {
  return request({
    url: "/common/getExpress",
    method: "get",
    params
  });
}